import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="footer">
            <div className="container d-flex justify-content-between align-items-center">
                <div>
                    © {new Date().getFullYear()} LOCI. All rights reserved.
                </div>
                <Link
                    to="/privacy-policy"
                    className="text-primary"
                    style={{ textDecoration: 'underline' }}
                >
                    Privacy Policy
                </Link>
            </div>
        </footer>
    );
}

export default Footer;